export const regionSelector = {
  title: "Select a region to login",
  us: "United States",
  usSubtitle: "Login to US",
  ca: "Canada",
  caSubtitle: "Login to CA",
} as const;
